/* import __COLOCATED_TEMPLATE__ from './option-checkbox-dropdown-item.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';

/*
  Upsell::OptionCheckboxDropdownItem

  This component is similar to Upsell::OptionCheckbox but different in a few key ways:
   - The PLUS badge is aligned to the right side of the dropdown popover
   - Clicking the label (including the PLUS badge) executes the passed in action

  @param {String} label - option checkbox label
  @param {String} vertical - The vertical that is using the tooltip.
                             It configures the brand color shown on the components/svgs/plus-badge-filled
                             Available verticals: ['restaurants', 'retail']
  @param {action} optionLabelClicked - action that occurs when the label (including the badge) is clicked
*/
let OptionCheckboxDropdownItem = (_dec = tagName(''), _dec(_class = class OptionCheckboxDropdownItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "optionLabelClicked", () => {});
  }
}) || _class);
export { OptionCheckboxDropdownItem as default };